(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diapo-creatur"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('bm-creator-slideshow')) {

    customElements.define('bm-creator-slideshow', class extends HTMLElement {

      connectedCallback() {

        this.controller?.abort();

        this.controller = new AbortController();

        if (document.readyState === 'loading') {

          document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true, signal: this.controller.signal });

        } else {

          this.initialize();

        }

      }

      initialize() {

        if (!this.isConnected) return;

        this.slides = [...this.querySelectorAll('[data-slide]')];

        if (!this.slides.length) return;

        this.current = 0;

        this.busy = false;

        this.editorPaused = false;

        this.hovered = false;

        this.focused = false;

        this.inView = true;

        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.userPaused = this.motion.matches;

        this.dots = [...this.querySelectorAll('[data-go]')];

        this.status = this.querySelector('[data-status]');

        this.speed = Number(this.dataset.duration) || 650;

        this.interval = Number(this.dataset.interval) || 5000;

        const options = { signal: this.controller.signal };

        this.slides.forEach(slide => { slide.hidden = false; });

        this.querySelectorAll('[data-previous], [data-next], .bm-creator-slideshow__dots').forEach(el => { el.hidden = false; });

        this.render(0);

        this.classList.add('is-ready');

        this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.current - 1, -1, true), options);

        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.current + 1, 1, true), options);

        this.dots.forEach(dot => dot.addEventListener('click', () => this.show(Number(dot.dataset.go), Number(dot.dataset.go) >= this.current ? 1 : -1, true), options));

        this.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch' && this.dataset.pauseHover === 'true') { this.hovered = true; this.schedule(); } }, options);

        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);

        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);

        this.addEventListener('focusout', event => { this.focused = !!event.relatedTarget && this.contains(event.relatedTarget); this.schedule(); }, options);

        this.addEventListener('keydown', event => {

          if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;

          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

          event.preventDefault();

          this.show(this.current + (event.key === 'ArrowRight' ? 1 : -1), event.key === 'ArrowRight' ? 1 : -1, true);

        }, options);

        this.addEventListener('dragstart', event => { if (event.target.tagName === 'IMG') event.preventDefault(); }, options);

        this.addEventListener('pointerdown', event => { if (event.pointerType === 'touch') this.touchStart = { x: event.clientX, y: event.clientY }; }, options);

        this.addEventListener('pointerup', event => {

          if (!this.touchStart) return;

          const dx = event.clientX - this.touchStart.x;

          const dy = event.clientY - this.touchStart.y;

          this.touchStart = null;

          if (Math.abs(dx) < 50 || Math.abs(dx) <= Math.abs(dy) * 1.3) return;

          this.suppressClickUntil = performance.now() + 500;

          this.show(this.current + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1, true);

        }, options);

        this.addEventListener('pointercancel', () => { this.touchStart = null; }, options);

        this.addEventListener('click', event => { if (performance.now() < (this.suppressClickUntil || 0)) { event.preventDefault(); event.stopPropagation(); } }, { ...options, capture: true });

        document.addEventListener('visibilitychange', () => this.schedule(), options);

        this.motion.addEventListener('change', event => { if (event.matches) this.userPaused = true; this.schedule(); }, options);

        document.addEventListener('shopify:block:select', event => {

          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);

          if (index < 0) return;

          this.editorPaused = true;

          this.cancelAnimation();

          this.render(index);

          this.schedule();

        }, options);

        document.addEventListener('shopify:block:deselect', event => {

          if (!this.slides.some(slide => slide.dataset.blockId === event.detail?.blockId)) return;

          this.editorPaused = false;

          this.schedule();

        }, options);

        if ('IntersectionObserver' in window) {

          this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.schedule(); }, { threshold: 0.05 });

          this.observer.observe(this);

        }

        this.schedule();

      }

      render(index) {

        this.current = index;

        this.slides.forEach((slide, i) => {

          slide.style.transition = 'none';

          slide.style.transform = i === index ? 'translateX(0)' : 'translateX(100%)';

          slide.classList.toggle('is-active', i === index);

          slide.inert = i !== index;

          slide.setAttribute('aria-hidden', String(i !== index));

        });

        this.updateState();

      }

      updateState() {

        this.dots.forEach(dot => {

          if (Number(dot.dataset.go) === this.current) dot.setAttribute('aria-current', 'true');

          else dot.removeAttribute('aria-current');

        });

        this.status.textContent = this.slides[this.current].getAttribute('aria-label');

      }

      show(index, direction, manual = false) {

        if (this.busy || this.slides.length < 2) return;

        index = (index + this.slides.length) % this.slides.length;

        if (index === this.current) return;

        clearTimeout(this.timer);

        this.busy = true;

        const outgoing = this.slides[this.current];

        const incoming = this.slides[index];

        const transferFocus = outgoing.contains(document.activeElement);

        incoming.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });

        incoming.style.transition = 'none';

        incoming.style.transform = `translateX(${direction * 100}%)`;

        incoming.offsetWidth;

        incoming.style.transition = '';

        outgoing.style.transition = '';

        outgoing.classList.remove('is-active');

        outgoing.inert = true;

        outgoing.setAttribute('aria-hidden', 'true');

        incoming.inert = false;

        incoming.setAttribute('aria-hidden', 'false');

        this.current = index;

        this.status.setAttribute('aria-live', manual ? 'polite' : 'off');

        this.updateState();

        if (transferFocus) (incoming.querySelector('a') || this).focus({ preventScroll: true });

        this.frame = requestAnimationFrame(() => {

          incoming.classList.add('is-active');

          incoming.style.transform = 'translateX(0)';

          outgoing.style.transform = `translateX(${-direction * 100}%)`;

          this.finishTimer = setTimeout(() => { this.busy = false; this.schedule(); }, this.motion.matches ? 0 : this.speed);

        });

      }

      schedule() {

        clearTimeout(this.timer);

        if (!this.isConnected || this.slides.length < 2 || this.dataset.autoplay !== 'true' || this.userPaused || this.hovered || this.focused || this.editorPaused || !this.inView || document.hidden || this.busy) return;

        this.timer = setTimeout(() => this.show(this.current + 1, 1), this.interval);

      }

      cancelAnimation() {

        cancelAnimationFrame(this.frame);

        clearTimeout(this.finishTimer);

        this.busy = false;

      }

      disconnectedCallback() {

        this.controller?.abort();

        clearTimeout(this.timer);

        this.cancelAnimation();

        this.observer?.disconnect();

      }

    });

  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bm-richtext-section-v2')) {
  customElements.define('bm-richtext-section-v2', class extends HTMLElement {
    connectedCallback() {
      this.startTimer = setTimeout(() => this.initialize(), 0);
    }

    disconnectedCallback() {
      clearTimeout(this.startTimer);
      cancelAnimationFrame(this.frame);
      this.resizeObserver?.disconnect();
      this.textObserver?.disconnect();
      this.linkObserver?.disconnect();
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
      window.removeEventListener('resize', this.scheduleMeasure);
    }

    initialize() {
      const config = this.querySelector('[data-bm-text-config]');
      if (!config) return;
      const entries = JSON.parse(config.textContent);
      const assigned = new Set();
      const normalize = value => value.replace(/\s+/g, ' ').trim();
      const blocks = entries.map(entry => {
        let block = this.querySelector(`[data-block-id="${CSS.escape(entry.id)}"]`);
        if (!block) {
          block = Array.from(this.querySelectorAll('[data-shopify-editor-block]')).find(element => {
            try {
              const id = JSON.parse(element.getAttribute('data-shopify-editor-block')).id;
              return id === entry.id || id.endsWith(`__${entry.id}`);
            } catch { return false; }
          });
        }
        if (!block) {
          const template = document.createElement('template');
          template.innerHTML = entry.html;
          const expected = normalize(template.content.textContent);
          const candidates = [...this.querySelectorAll('.rte'), ...this.querySelectorAll('div')];
          block = candidates.find(element => expected && !assigned.has(element) &&
            !Array.from(assigned).some(previous => element.contains(previous) || previous.contains(element)) &&
            normalize(element.textContent) === expected);
        }
        if (block) {
          assigned.add(block);
          block.dataset.bmParagraph = entry.id;
          this.styleLinks(block);
        }
        return block;
      }).filter(Boolean);
      this.linkObserver?.disconnect();
      this.linkObserver = new MutationObserver(() => blocks.forEach(block => this.styleLinks(block)));
      blocks.forEach(block => this.linkObserver.observe(block, { subtree: true, childList: true }));
      if (this.dataset.expandEnabled !== 'true') return;
      if (!this.groups) {
        const textBlocks = new Set(blocks);
        const used = new Set();
        this.groups = [];
        blocks.forEach(block => {
          if (used.has(block)) return;
          const run = [block];
          let next = block.nextElementSibling;
          while (next && textBlocks.has(next)) {
            run.push(next);
            next = next.nextElementSibling;
          }
          run.forEach(item => used.add(item));
          const wrapper = document.createElement('div');
          wrapper.className = 'bm-text-accordion';
          const parentGap = getComputedStyle(block.parentElement).rowGap;
          wrapper.style.setProperty('--bm-paragraph-gap', parentGap === 'normal' ? '0px' : parentGap);
          const content = document.createElement('div');
          content.className = 'bm-text-accordion__content';
          content.id = `bm-text-${this.dataset.sectionId}-${this.groups.length}`;
          const button = document.createElement('button');
          button.className = 'bm-text-accordion__toggle';
          button.type = 'button';
          button.hidden = true;
          button.setAttribute('aria-controls', content.id);
          button.setAttribute('aria-expanded', 'false');
          button.textContent = this.dataset.more || 'Voir plus';
          block.before(wrapper);
          wrapper.append(content, button);
          run.forEach(item => content.append(item));
          const group = { wrapper, content, button, expanded: false, limit: null, tabStates: new Map() };
          button.addEventListener('click', () => {
            const buttonTop = button.getBoundingClientRect().top;
            group.expanded = !group.expanded;
            this.applyState(group);
            if (!group.expanded && button.getBoundingClientRect().top < 0) {
              window.scrollBy({ top: button.getBoundingClientRect().top - Math.max(20, buttonTop), behavior: 'instant' });
            }
          });
          this.groups.push(group);
        });
      }
      this.scheduleMeasure = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.measure());
      };
      this.resizeObserver = new ResizeObserver(this.scheduleMeasure);
      this.groups.forEach(group => this.resizeObserver.observe(group.content));
      this.textObserver = new MutationObserver(this.scheduleMeasure);
      this.groups.forEach(group => this.textObserver.observe(group.content, { subtree: true, characterData: true, childList: true }));
      this.onBlockSelect = event => {
        this.groups.forEach(group => {
          if (group.content.contains(event.target)) {
            group.expanded = true;
            this.applyState(group);
          }
        });
      };
      this.addEventListener('shopify:block:select', this.onBlockSelect);
      window.addEventListener('resize', this.scheduleMeasure);
      document.fonts?.ready.then(() => { if (this.isConnected) this.scheduleMeasure(); });
      this.scheduleMeasure();
    }


    styleLinks(block) {
      block.querySelectorAll('a').forEach(link => {
        link.style.setProperty('color', 'var(--bm-paragraph-link-color)', 'important');
        link.style.setProperty('-webkit-text-fill-color', 'currentColor', 'important');
        link.style.setProperty('text-decoration', 'var(--bm-paragraph-link-decoration)', 'important');
        link.style.setProperty('border', '0', 'important');
        link.style.setProperty('box-shadow', 'none', 'important');
        link.style.setProperty('background-image', 'none', 'important');
        link.querySelectorAll('*').forEach(child => {
          child.style.setProperty('color', 'inherit', 'important');
          child.style.setProperty('-webkit-text-fill-color', 'currentColor', 'important');
          child.style.setProperty('text-decoration', 'none', 'important');
          child.style.setProperty('border', '0', 'important');
          child.style.setProperty('box-shadow', 'none', 'important');
          child.style.setProperty('background-image', 'none', 'important');
        });
        let ancestor = link.parentElement;
        while (ancestor && block.contains(ancestor)) {
          ancestor.style.setProperty('text-decoration', 'none', 'important');
          if (ancestor === block) break;
          ancestor = ancestor.parentElement;
        }
      });
    }

    measure() {
      this.groups.forEach(group => {
        const { content } = group;
        if (content.getBoundingClientRect().width === 0) return;
        const rects = [];
        const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          if (!node.textContent.trim()) continue;
          const range = document.createRange();
          range.selectNodeContents(node);
          Array.from(range.getClientRects()).forEach(rect => {
            if (rect.width > 0 && rect.height > 0) rects.push({ top: rect.top, bottom: rect.bottom });
          });
        }
        content.querySelectorAll('br').forEach(br => {
          const rect = br.getBoundingClientRect();
          if (rect.height > 0) rects.push({ top: rect.top, bottom: rect.bottom });
        });
        rects.sort((a, b) => a.top - b.top || a.bottom - b.bottom);
        const lines = [];
        rects.forEach(rect => {
          const previous = lines[lines.length - 1];
          const overlap = previous ? Math.min(previous.bottom, rect.bottom) - Math.max(previous.top, rect.top) : 0;
          if (previous && overlap > Math.min(previous.bottom - previous.top, rect.bottom - rect.top) / 2) {
            previous.top = Math.min(previous.top, rect.top);
            previous.bottom = Math.max(previous.bottom, rect.bottom);
          } else {
            lines.push({ ...rect });
          }
        });
        group.limit = lines.length > 10 ? Math.ceil(lines[9].bottom - content.getBoundingClientRect().top + 1) : null;
        if (group.limit !== null) content.style.setProperty('--bm-collapsed-height', `${group.limit}px`);
        this.applyState(group);
      });
    }

    applyState(group) {
      const collapsed = group.limit !== null && !group.expanded;
      group.content.dataset.collapsed = String(collapsed);
      group.button.hidden = group.limit === null;
      group.button.setAttribute('aria-expanded', String(!collapsed));
      group.button.textContent = group.expanded ? (this.dataset.less || 'Voir moins') : (this.dataset.more || 'Voir plus');
      const cutoff = group.content.getBoundingClientRect().top + (group.limit || 0);
      group.content.querySelectorAll('a[href], button, input, select, textarea, [tabindex]').forEach(element => {
        if (collapsed && element.getBoundingClientRect().bottom > cutoff + 1) {
          if (!group.tabStates.has(element)) group.tabStates.set(element, element.getAttribute('tabindex'));
          element.setAttribute('tabindex', '-1');
        } else if (group.tabStates.has(element)) {
          const previous = group.tabStates.get(element);
          if (previous === null) element.removeAttribute('tabindex');
          else element.setAttribute('tabindex', previous);
          group.tabStates.delete(element);
        }
      });
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
